import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

// Utils
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

// Services
import useCampService from '../../../../../../../services/campService';

// Components
import SelectField from '../../../../../../atoms/SelectField/SelectField';

function Features({ formik }) {
  const { t } = useTranslation();

  const { getCampFeatures, getCampTags } = useCampService();

  const { data: features, isLoading: isFeaturesLoading } = useQuery('getCampFeatures', getCampFeatures);
  const { data: tags, isLoading: isTagsLoading } = useQuery('getCampTags', getCampTags);

  const getSelect = useCallback((name, options, transKeyForOptions, isLoading, maxNumberOfItems) => (
    <SelectField
      id={name}
      name={name}
      options={options?.map((option) => ({ label: t(`${transKeyForOptions}.${option}`), value: option }))}
      label={t(`camps.marketing.form.${name}`)}
      error={formik.errors?.[name] && formik.touched?.[name] ? formik.errors[name] : null}
      setFieldTouched={formik.setFieldTouched}
      setFieldValue={formik.setFieldValue}
      value={formik.values[name]}
      isMulti
      disabled={isLoading}
      withTags
      maxNumberOfItems={maxNumberOfItems}
      isRequired
    />
  ), [formik]);

  return (
    <div>
      <h3 className="fs-20 m-b-25">{t('camps.marketing.sub.features')}</h3>

      <div className="input_max">
        {getSelect('features', features?.data?.campFeatures, 'camps.features', isFeaturesLoading, 5)}
      </div>

      <hr className="m-t-30 m-b-40" />
      <h3 className="fs-20 m-b-25">{t('camps.marketing.sub.tags')}</h3>

      <div className="input_max">
        {getSelect('tags', tags?.data?.campTags, 'camps.tags', isTagsLoading, null)}
      </div>
    </div>
  );
}

Features.propTypes = {
  formik: PropTypes.shape({
    values: PropTypes.shape({}),
    errors: PropTypes.shape({}),
    touched: PropTypes.shape({}),
    setFieldTouched: PropTypes.func,
    setFieldValue: PropTypes.func,
  }).isRequired,
};

export default Features;
